<template>
    <div class="form-group">
        <label v-if="label" :for="id || name">{{ label }}</label>
        <div class="position-relative">
            <DatePicker v-model="includedValue"
                        mode="time"
                        :is24hr="true"
                        title-position="left"
                        :popover="{transition:`fade-slide`, visibility: 'click'}">
                <template v-slot="{ inputValue, inputEvents }">
                    <input
                        readonly
                        class="form-control"
                        :class="{'is-invalid' : !isValid, [className]: className}"
                        type="text"
                        :id="id || name"
                        :name="name"
                        :placeholder="placeholder"
                        :value="inputValue"
                        v-on="inputEvents"
                        autocomplete="off"
                        :disabled="disabled"
                    />
                    <div v-if="!isValid && typeof v === 'string' && showError" class="invalid-feedback">{{ v }}</div>
                    <div v-else-if="!isValid && !v.required && typeof v.required !== 'undefined' && showError"
                         class="invalid-feedback">The field is required.
                    </div>
                    <div v-else-if="!isValid && !v.date && typeof v.date !== 'undefined' && showError"
                         class="invalid-feedback">Date format is invalid.
                    </div>
                </template>
            </DatePicker>
        </div>

    </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    name: "InputHour",
    components: {DatePicker},
    data: () => ({
        format: 'HH:mm',
        includedValue: null,
    }),
    mounted() {
        if (!this.disabled){
            this.assignIncludedValue(this.value);
        }

    },
    props: {
        label: String,
        id: String,
        className: String,
        placeholder: String,
        disabled: Boolean,
        name: {
            type: String,
            required: true
        },
        value: {
            type: [Date, String, undefined, null],
            default: new Date(),
        },
        showError: {
            type: Boolean,
            default: true,
        },
        v: [Object, String, undefined, null],
    },
    watch: {
        value(value){
            this.assignIncludedValue(value);
        },

        includedValue(value) {
            if(value){
                value = moment(value).format('HH:mm');
            }
            const {name} = this;
            this.$emit('change', {name, value})
        },

        disabled(value){
            if(value){
                this.includedValue = null;
            } else{
                this.includedValue = new Date();
            }
        }
    },
    computed: {
        isValid() {
            if ([null, undefined].indexOf(this.v) > -1) return true;
            return typeof this.v === 'string' ? false : !this.v.$error
        }
    },
    methods: {
        assignIncludedValue(value){
            if(!value) return;

            if(typeof value === "string"){
                this.includedValue = moment(value, this.format).toString();
            } else{
                this.includedValue = moment(value).toString();
            }
        }
    }
}
</script>
<style scoped lang="scss">
$icon: url("data:image/svg+xml,<svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' fill='#{$gray-600}'><path d='M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z'/><path d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z'/></svg>");

.form-control {
    padding-right: $input-height-inner;
    background-repeat: no-repeat;
    background-position: right $input-height-inner-quarter center;
    background-image: escape-svg($icon);

    &:not(.disabled, :disabled){
        cursor: pointer;
        background-color: $input-bg;
    }

    &.disabled, &:disabled{
        cursor: not-allowed;
    }
}
</style>
<style lang="scss">

.form-group {
    .vc-popover-content-wrapper {
        left: 50% !important;
        transform: translate(-50%, 100%) !important;
        bottom: 0 !important;
        top: auto !important;
        min-width: 100%;
    }

    .vc-popover-content {
        border: $input-border-width solid $input-border-color;
        box-shadow: none;
        transform-origin: top;

        &.direction-bottom {
            margin: 0.125rem 0 0;width: 100%;

        }
    }

    .vc-popover-caret {
        display: none;
    }

    .vc-container{
        width: 100%;
        display: block;
    }

    .vc-time-picker {
        .vc-date {
            display: none !important
        }
        .vc-select {
            select{
                text-align: center;
                width: 85px;
            }
        }
    }

    .vc-highlight {
        background-color: $primary !important;
    }

}


.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.2s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-out;
    pointer-events: none;
}

.fade-slide-enter,
.fade-slide-leave-to {
    opacity: 0;

    &.direction-bottom {
        transform: scale(0.75) translateY(-19px);
    }

}

.fade-slide-enter-to,
.fade-slide-leave {
    opacity: 1;

    &.direction-bottom {
        transform: scale(1) translateY(0);
        pointer-events: auto;
    }
}
</style>